import Button from "@/common/components/Button";
import DropdownMenu from "@/common/components/DropdownMenu";
import { useMenu } from "@/common/stores/menu";
import { twMerge } from "tailwind-merge";
import EstablishmentMapActionPriceSearch from "./PriceSearch";
import { useEstablishmentMap } from "@/features/establishments/stores/useEstablishmentMap.store";

const EstablishmentMapActions = () => {
  const { collapse } = useMenu();

  const { action, updateAction } = useEstablishmentMap();

  return (
    <>
      {!action && (
        <div className="absolute z-20 bottom-6 right-2">
          <DropdownMenu
            triggerClassName="bg-primary-blue hover:bg-primary-blue-hover"
            triggerLabel="Ações"
            options={[
              {
                label: 'Busca de preços',
                onClick: () => updateAction({ name: 'price_search' }),
              }
            ]}
          />
        </div>
      )}

      {action && (
        <div className={
          twMerge(
            'absolute z-20 bottom-0 bg-map-search-75 backdrop-blur px-4 pt-4 pb-6 w-[calc(100vw-283px)] flex items-center justify-between',
            collapse && 'w-[calc(100vw-88px)]'
          )
        }>
          <div>
            {action?.name === 'price_search' && <EstablishmentMapActionPriceSearch />}
          </div>

          <div className="-me-2 flex items-center gap-4">
            <Button variant='outline-error' onClick={() => updateAction(undefined)}>
              Cancelar
            </Button>

            <DropdownMenu
              triggerClassName="bg-primary-blue hover:bg-primary-blue-hover"
              triggerLabel="Ações"
              options={[
                {
                  label: 'Busca de preços',
                  onClick: () => updateAction({ name: 'price_search' }),
                }
              ]}
            />
          </div>
        </div>
      )}
    </>

  );
};

export default EstablishmentMapActions;
